import React from "react";
import DealStage from "@/model/interface/DealStage";
import { PipelineSummary } from "@/model/interface/Deal";
import { DealStageCategory, stageCategoryOf } from "@/enum/DealStageCategory";

interface PipelineSummaryCardsProps {
  stages: DealStage[];
  summary?: PipelineSummary;
  showLeads: boolean;
}

export function PipelineSummaryCards({ stages, summary, showLeads }: PipelineSummaryCardsProps) {
  if (!summary) {
    return null;
  }

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className="flex flex-wrap gap-2 px-4 py-2">
      <div className="flex items-center gap-2 bg-muted/50 rounded-lg px-3 py-2 text-sm whitespace-nowrap">
        <span className="text-muted-foreground">Pipeline Deals</span>
        <span className="font-semibold tabular-nums">{summary.pipelineDealCount}</span>
      </div>
      <div className="flex items-center gap-2 bg-muted/50 rounded-lg px-3 py-2 text-sm whitespace-nowrap">
        <span className="text-muted-foreground">Pipeline Value</span>
        <span className="font-semibold tabular-nums">{formatCurrency(summary.totalPipelineValue)}</span>
      </div>
      {showLeads && (
        <div className="flex items-center gap-2 bg-muted/50 rounded-lg px-3 py-2 text-sm whitespace-nowrap">
          <span className="text-muted-foreground">Leads</span>
          <span className="font-semibold tabular-nums">{summary.leadDealCount}</span>
          <span className="text-xs text-muted-foreground">not in the total</span>
        </div>
      )}
      {stages
        .filter((stage) => stage.isActive && !stage.isClosed)
        .map((stage) => (
          <div
            key={stage.id}
            className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm whitespace-nowrap"
            style={{ backgroundColor: `${stage.color}15` }}
          >
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: stage.color }} />
            <span className="text-muted-foreground">{stage.name}</span>
            <span className="font-semibold tabular-nums">{summary.stageCounts[stage.id] || 0}</span>
            {stageCategoryOf(stage) === DealStageCategory.PIPELINE && summary.stageValues[stage.id] != null && (
              <span className="text-xs text-muted-foreground tabular-nums">
                {formatCurrency(summary.stageValues[stage.id])}
              </span>
            )}
          </div>
        ))}
    </div>
  );
}
